import classNames from 'classnames';
import { List, ListProps } from 'yoso';
import './InlineList.scss';

export type InlineListProps = ListProps & {
  divided?: boolean;
};
export const InlineList = ({ className, divided, ...props }: InlineListProps) => (
  <List
    className={classNames('inline-list', { 'inline-list-divided': divided }, className)}
    {...props}
  />
);
